module.exports = __webpack_public_path__ + "static/media/DMI1234.403fe1cf.png";